module.exports = __webpack_public_path__ + "static/media/Pamela Adams.bf7fa676.png";